/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize, borderRadius } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { media } from '@atlassian/bitkit-responsive';

import { CenteredRow } from 'src/styles';
import { overflowEllipsis } from 'src/styles/mixins';

export { CurrentEntryPathSegment, LinkedPathSegment } from './path.style';

const colPaddingFileSize = gridSize() * 2;
const colWidthIcon = gridSize() * 3;
const colWidthFileSize = gridSize() * 9;
const colWidthCommitMessage = gridSize() * 30;
const colWidthCommitDate = gridSize() * 14;

export const DirectoryListRow = styled.tr({
  '& > td': {
    paddingBottom: `${gridSize()}px`,
    paddingTop: `${gridSize()}px`,
  },
  '&:hover, &:focus': {
    backgroundColor: token('elevation.surface.raised.hovered'),
    boxShadow: token('elevation.shadow.raised'),
    borderRadius: `${borderRadius()}px`,
  },
});

export const DirectoryList = styled.div({
  paddingBottom: `${gridSize() * 4}px`,
});

export const ItemSizeHeader = styled.th({
  color: token('color.text.subtlest'),
  minWidth: `${colWidthFileSize}px`,
  paddingRight: `${colPaddingFileSize}px`,
  textAlign: 'right',
  width: `${colWidthFileSize}px`,
});

export const ItemCommitDateHeader = styled.th({
  color: token('color.text.subtlest'),
  minWidth: `${colWidthCommitDate}px`,
  width: `${colWidthCommitDate}px`,
});

export const ItemIconCell = styled.td({
  minWidth: `${colWidthIcon}px`,
  width: `${colWidthIcon}px`,
});

// Can't create a `styled(Link)` because Flow doesn't think `Link`
// is a React$Component
export const ItemNameHeader = styled.th({
  color: token('color.text.subtlest'),
});

export const ItemNameCell = styled.td({
  maxWidth: '500px',
  'a, a:hover, a:focus': {
    color: token('color.text'),
  },
});

export const ItemSizeCell = styled.td({
  paddingRight: `${colPaddingFileSize}px`,
  textAlign: 'right',
});

export const ItemMessageHeader = styled.th({
  fontWeight: token('font.weight.bold'),
  color: token('color.text.subtlest'),
});

export const ItemCommitMessageCell = styled.td(
  overflowEllipsis(`${colWidthCommitMessage}px`),
  {
    minWidth: `${colWidthCommitMessage}px`,
  }
);

export const ItemIcon = styled.div({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  'a, a:hover, a:focus': {
    color: 'inherit',
  },
});

export const PathHeader = styled.div({
  display: 'flex',
  alignItems: 'flex-start',
});

export const DirectoryHeader = styled.div({
  margin: `${gridSize() * 2}px 0 ${gridSize()}px`,
  paddingTop: `${gridSize() / 4}px`,
  paddingBottom: `${gridSize() / 4}px`,
});

export const IconWrapper = styled.div({
  flexShrink: 0,
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
  lineHeight: 0,
});

export const PathWrapper = styled.span({
  font: token('font.body.large'),
  marginLeft: `${gridSize()}px`,
  /* Override @atlaskit/panel styles */
  textTransform: 'none',
});

export const SubtleLink = styled.a({
  color: 'inherit',
  display: 'block',
});

// Set the max-width to 600px for the DirectoryFilter on the Source page to make RefSelectorWrapper responsive
// 600px = RefSelectorWrapper max-width 400px + Input filter width 184px and margin-left 16px.
export const DirectoryFilter = styled.div(
  {
    display: 'flex',
    alignItems: 'center',
    maxWidth: `${gridSize() * 75}px`,
    /* Spacing between AK component */
    '> div + div': {
      marginLeft: `${gridSize() * 2}px`,
    },
  },
  media.upToSmall(`
    flex-direction: column;
    align-items: flex-start;

    & > div + div {
    margin-left: 0;
    width: 100%;
  }
  `)
);

export const ListFooter = styled(CenteredRow)({
  padding: `${gridSize()}px 0`,
});

export const FilterMessage = styled.span({
  alignSelf: 'center',
  display: 'inline-block',
  marginLeft: `${gridSize()}px`,
});

export const LinkInnerWrapper = styled.span({
  display: 'inline-flex',
  alignItems: 'center',
  maxWidth: '100%',
});

export const LinkIconContainer = styled.span({
  display: 'inline-block',
  flexShrink: 0,
  marginRight: `${gridSize() * 2}px`,
});

export const LinkTextContainer = styled.span(
  {
    flexGrow: 1,
  },
  overflowEllipsis()
);
